module.exports = "import React from 'react';\nimport { Button } from 'reactstrap';\n\nexport default (props) => {\n  return (\n    <Button color=\"danger\">Danger!</Button>\n  );\n};\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./docs/lib/examples/import-basic.js
// module id = 434
// module chunks = 0